import { useState } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Labelled password input with a visibility toggle.
 *
 * This markup previously existed three times over — once in Login and
 * twice in Register — each with the same block of inline positioning
 * styles and a FontAwesome eye. Extracted once, with the icon drawn as
 * inline SVG so it inherits currentColor and costs no icon font.
 */

const EyeIcon = ({ off }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        <path d="M1.8 12S5.4 5.4 12 5.4 22.2 12 22.2 12 18.6 18.6 12 18.6 1.8 12 1.8 12Z" />
        <circle cx="12" cy="12" r="3.1" />
        {off && <line x1="3.5" y1="20.5" x2="20.5" y2="3.5" />}
    </svg>
)

const PasswordField = ({
    id,
    label,
    value,
    onChange,
    autoComplete = 'current-password',
    inputRef,
    required = true,
}) => {
    const { t } = useTranslation()
    const [visible, setVisible] = useState(false)

    return (
        <div className="auth__field">
            <label className="form__label" htmlFor={id}>{label}</label>
            <div className="auth__field-wrap">
                <input
                    className="form__input"
                    type={visible ? 'text' : 'password'}
                    id={id}
                    ref={inputRef}
                    value={value}
                    onChange={onChange}
                    autoComplete={autoComplete}
                    required={required}
                />
                <button
                    type="button"
                    className="auth__peek"
                    aria-label={visible ? t('auth.hidePassword') : t('auth.showPassword')}
                    aria-pressed={visible}
                    onClick={() => setVisible((prev) => !prev)}
                >
                    <EyeIcon off={visible} />
                </button>
            </div>
        </div>
    )
}

export default PasswordField
